import { css } from '@emotion/react';
import { darkThemeStyle, theme } from '../theme';
import { tokens } from '../tokens';
export const DROPDOWN_MIN_WIDTH = 260;
/** Equivalent to the height of a menu with 7 basic items */
export const DROPDOWN_MAX_HEIGHT = 268;
const sizeMap = {
    large: {
        descriptionFontSize: tokens.fontSizes.medium,
        minHeight: tokens.sizing.large,
    },
    medium: {
        descriptionFontSize: tokens.fontSizes.small,
        minHeight: tokens.sizing.medium,
    },
};
const dropdownStaticStyle = css({
    backgroundColor: theme.background.contrast,
    border: `${tokens.borderWidth.thin} solid ${theme.border.main}`,
    borderRadius: tokens.borderRadius.medium,
    boxShadow: theme.boxShadow.xthick,
    listStyle: 'none',
    margin: 0,
    maxHeight: DROPDOWN_MAX_HEIGHT,
    minWidth: DROPDOWN_MIN_WIDTH,
    outline: 0,
    overflow: 'auto',
    padding: `${tokens.spacingNew.xsmall} 0`,
    position: 'absolute',
    width: DROPDOWN_MIN_WIDTH,
});
export function dropdownStyle({ hasParentModal, inverted, x, y, }) {
    return [
        ...(inverted ? [darkThemeStyle] : []),
        dropdownStaticStyle,
        css({
            left: x !== null && x !== void 0 ? x : 0,
            top: y !== null && y !== void 0 ? y : 0,
            zIndex: hasParentModal ? tokens.zIndex.modal : tokens.zIndex.dropdown,
        }),
    ];
}
const itemStaticStyle = css({
    '& > svg': {
        marginTop: '2px',
    },
    ':disabled': {
        cursor: 'default',
        opacity: tokens.opacity.medium,
        pointerEvents: 'none',
    },
    alignItems: 'center',
    border: 0,
    borderRadius: tokens.borderRadius.medium,
    color: theme.text.main,
    cursor: 'pointer',
    display: 'flex',
    marginLeft: tokens.spacingNew.xsmall,
    marginRight: tokens.spacingNew.xsmall,
    outline: 0,
    padding: `${tokens.spacingNew.xsmall} 12px`,
    position: 'relative',
    textDecoration: 'none',
    transition: 'background-color 125ms ease-out',
    width: 'calc(100% - 16px)',
});
export function itemStyle({ isActive, isFocusVisible, size, }) {
    return [
        itemStaticStyle,
        css(Object.assign(Object.assign({ background: isActive ? theme.background.active : 'transparent', minHeight: sizeMap[size].minHeight }, (!isActive && {
            '&:hover': {
                backgroundColor: theme.background.hover,
            },
        })), (isFocusVisible && {
            boxShadow: `inset 0 0 0 2px ${theme.border.focusOutline}`,
        }))),
    ];
}
const itemInnerContentStaticStyle = css({
    display: 'flex',
    flexGrow: 1,
    overflow: 'hidden',
});
export function itemInnerContentStyle({ hasDescription, hasLeftDecor, hasRightDecor, }) {
    return [
        itemInnerContentStaticStyle,
        css(Object.assign(Object.assign({ alignItems: hasDescription ? 'flex-start' : 'center', flexDirection: hasDescription ? 'column' : 'row' }, (hasLeftDecor && { paddingLeft: tokens.spacingNew.xsmall })), (hasRightDecor && { paddingRight: tokens.spacingNew.xsmall }))),
    ];
}
const itemLabelStaticStyle = css({
    color: 'inherit',
    display: 'block',
    overflow: 'hidden',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
});
// Inherits text color to keep it in sync with icon color in case of custom style overrides
export function itemLabelStyle({ hasDescription, isActive, isVirtual, }) {
    return [
        itemLabelStaticStyle,
        css({
            fontWeight: isActive && !isVirtual
                ? tokens.fontWeights.bold
                : tokens.fontWeights.regular,
            lineHeight: hasDescription
                ? tokens.lineHeights.relaxed
                : tokens.lineHeights.default,
        }),
    ];
}
const itemDescriptionStaticStyle = css({
    color: theme.text.subtle,
    display: 'block',
    marginTop: '2px',
    textAlign: 'left',
});
export function itemDescriptionStyle({ size }) {
    return [
        itemDescriptionStaticStyle,
        css({
            fontSize: sizeMap[size].descriptionFontSize,
        }),
    ];
}
export const categoryDividerStaticStyle = css({
    backgroundColor: theme.border.main,
    height: '1px',
    margin: tokens.spacingNew.xsmall,
});
export const categoryLabelStaticStyle = css({
    color: theme.text.subtle,
    fontSize: tokens.fontSizes.xsmall,
    fontWeight: tokens.fontWeights.bold,
    letterSpacing: tokens.letterSpacing.relaxed,
    lineHeight: tokens.lineHeights.default,
    margin: 0,
    padding: `${tokens.spacingNew.xsmall} ${tokens.spacingNew.medium}`,
    textTransform: 'uppercase',
    userSelect: 'none',
});
